// import axios from "axios";

// export default {
//   created: function () {
//     this.token = localStorage.getItem("token");
//   },
//   data: function () {
//     return {
//       token: "",
//       apiUrl: process.env.VUE_APP_SERVER,
//     };
//   },
//   methods: {
//     deleteToken: function () {
//       localStorage.removeItem("token");
//       // localStorage.removeItem("vuex");
//     },
//     logout: function () {
//       this.deleteToken("/");
//       this.$router.push("/login");
//       // this.$router.push("/");
//     },
//     axiosCall: function (url, method, data, setToken) {
//       let options = {
//         method: method,
//         url: this.apiUrl + url,
//         data: data,
//         headers: {},
//       };

//       if (method.toLowerCase() === "get" && data) {
//         if (Object.keys(data).length > 0) {
//           options.params = data;
//         }
//       }

//       if (setToken == undefined || setToken) {
//         if (this.token) {
//           options.headers = {
//             Authorization: `Bearer ${this.token}`,
//           };
//         }
//       }

//       return axios(options).catch((error) => {
//         console.log(error.response);
//         if (error.response.status == 401) {
//           this.logout();
//           location.reload();
//         } else {
//           return error.response;
//         }
//       });
//     },

//     axiosCall2: function (url, method, data) {
//       let options = {
//         method: method,
//         url: url,
//         data: data,
//         headers: {},
//       };

//       if (method.toLowerCase() === "get" && data) {
//         if (Object.keys(data).length > 0) {
//           options.params = data;
//         }
//       }

//       return axios(options).catch((error) => {
//         console.log(error.response);
//         return error.response;
//       });
//     },
//     findPropertyValue: function (obj, keyToFind) {
//       let result = null;

//       function search(obj) {
//         if (typeof obj !== "object" || obj === null) return;

//         for (const key in obj) {
//           if (key === keyToFind) {
//             result = obj[key];
//             return;
//           }

//           search(obj[key]);
//         }
//       }
 
//       search(obj);
//       return result;
//     },
//   },
// };


import axios from "axios";

export default {
  created: function () {
    this.token = localStorage.getItem("token");
  },
  data: function () {
    return {
      token: "",
      apiUrl: process.env.VUE_APP_SERVER,
    };
  },
  methods: {
    deleteToken: function () {
      localStorage.removeItem("token");
      // localStorage.removeItem("vuex");
    },
    logout: function () {
      this.deleteToken("/");
      this.$router.push("/login");
      // this.$router.push("/");
    },
    axiosCall: function (url, method, data, setToken) {
      let options = {
        method: method,
        url: this.apiUrl + url,
        data: data,
        headers: {},
      };

      if (method.toLowerCase() === "get" && data) {
        if (Object.keys(data).length > 0) {
          options.params = data;
        }
      }

      if (setToken == undefined || setToken) {
        if (this.token) {
          options.headers = {
            Authorization: `Bearer ${this.token}`,
          };
        }
      }

      return axios(options).catch((error) => {
        console.log(error.response);
        if (error.response.status == 401) {
          this.logout();
          location.reload();
        } else {
          return error.response;
        }
      });
    },
    axiosCall2: function (url, method, data) {
      let options = {
        method: method,
        url: url,
        data: data,
        headers: {},
      };

      if (method.toLowerCase() === "get" && data) {
        if (Object.keys(data).length > 0) {
          options.params = data;
        }
      }

      return axios(options).catch((error) => {
        console.log(error.response);
        return error.response;
      });
    },
    findPropertyValue: function (obj, keyToFind) {
      let result = null;

      function search(obj) {
        if (typeof obj !== "object" || obj === null) return;

        for (const key in obj) {
          if (key === keyToFind) {
            result = obj[key];
            return;
          }

          search(obj[key]);
        }
      }

      search(obj);
      return result;
    },
  },
};
